"use client";

import { useEffect } from "react";
import Script from "next/script";
import { isUSEnvironment } from "@utils/environment";

// Google Analytics IDs
const GA_ID_EU = "G-0VBWWN9MLE";
const GA_ID_US = "G-6P2HK901VQ";

export default function GoogleAnalytics() {
  const gaId = isUSEnvironment() ? GA_ID_US : GA_ID_EU;
  
  useEffect(() => {
    // This sets up Google Analytics on client side
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    gtag("js", new Date());
    gtag("config", gaId);
  }, [gaId]);

  return (
    <>
      {/* Google tag (gtag.js) */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}');
        `}
      </Script>
    </>
  );
}